// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3MKZl","itemTitle":"ClientEmergencyInfo_itemTitle__q660k","itemText":"ClientEmergencyInfo_itemText__32i_Q"};